import { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";
import {
    ButtonCreate,
    SearchTextField,
    PageHeaderTitle,
} from "../../Utils/Component";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import PublicForumCard from "./PublicForumCard/PublicForumCard";
import { AuthContext } from "../../Context/AuthContext";
import useGetPublicForumPaginate  from "../../Hooks/useGetPublicForumPaginate";
import PublicForumForm from "../../Components/PublicForum/PublicForumForm";
import { useNavigate } from "react-router-dom";
import {SelectDistrict} from "../../Components/Include/DynamicSelect";

export default function PublicForum() {

    const { t } = useContext(AuthContext);
    const navigate = useNavigate();
    const handleNavigateQuestionAndAnswer = (id) => {
        navigate(`/public-forum/question-and-anwser?publicForumId=${id}`);
    };

    const [district, setDistrict] = useState({id: "", title: ""})

    const { tableData, loading, refetch } = useGetPublicForumPaginate({districtId: district?.id});
    useEffect(() => {
        refetch();
    }, []);
   
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div className="page-container">
            <PageHeaderTitle
                classPage={t("class-page-title")}
                classSlash="slash-title"
                routeTo={"/public-forum"}
                pageTitle={t("page_public_forum")}
            />
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
                    <Typography className={t("class-name-text-field-title")}>
                        {t("filter_by_district")}
                    </Typography>
                    <SelectDistrict 
                        className={"text-field"}
                        capicalProvincesId={"65f3a1b2c4d5e6f7a8b9c0e1"}
                        value={district}
                        onChange={(val) => {
                            setDistrict(val)
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={8} lg={8} xl={9}>
                    <ButtonCreate
                        handleOpen={handleOpen}
                        classBtn={"btn-create"}
                        classIcon={"icon-add"}
                    />

                    <PublicForumForm
                        open={open}
                        handleClose={handleClose}
                        setRefetch={refetch}
                        dialogTitle="Create"
                    />
                </Grid>
            </Grid>
            <Box sx={{ marginTop: "20px" }}>
                <Grid container spacing={2}>
                    {loading ?
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                            <LoadingPage />
                        </Grid>
                        : tableData?.length === 0 || tableData?.length === undefined ?
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                <EmptyData />
                            </Grid>
                            : tableData?.map((e, index) => (
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={4} key={index}>
                                    <PublicForumCard item={e} setRefetch={refetch} handleNavigateQuestionAndAnswer={handleNavigateQuestionAndAnswer}/>
                                </Grid>
                            ))}
                </Grid>
            </Box>
        </div>
    );
}